const keyNames = {
  ENTER: 'Enter',
  SPACE: ' ',
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
  LEFT: 'ArrowLeft',
  RIGHT: 'ArrowRight',
};

export default keyNames;
